
import React, { useState } from 'react';
import { PrimaryButton } from '../Button/Button';
import { apiBaseUrl } from '../../util/api';

// Button to trigger Telia login flow, styled as primary
// Fetches OAuth URL from API, then redirects directly to Telia
const TeliaLoginButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  
  const handleClick = async () => {
    try {
      setIsLoading(true);
      
      // Redirect directly to our Telia login endpoint
      // This will handle OAuth URL generation and redirect to Telia
      const baseUrl = apiBaseUrl();
      window.location.href = `${baseUrl}/api/telia/login`;
      
    } catch (error) {
      console.error('Error starting Telia authentication:', error);
      setIsLoading(false);
      // TODO: Show error message to user
      alert('Failed to start Telia authentication. Please try again.');
    }
  };
  
  return (
    <PrimaryButton 
      type="button" 
      onClick={handleClick}
      disabled={isLoading}
    >
      {isLoading ? 'Starting authentication...' : 'Log in with Telia'}
    </PrimaryButton>
  );
};

export default TeliaLoginButton;
